export default "__VITE_ASSET__BhEucR26__"